import subscriptionApi from "@api/subscription";
import { useLayoutContext } from "@context/layout";
import { modalActions } from "@context/modals";
import { useIsMobile } from "@shared/hooks/useIsMobile";
import useRequestImmutable from "@shared/hooks/useRequestImmutable";
import { SUBSCRIPTION_ACTION } from "@types";
import { MODAL_TYPES } from "types/modals";
import { IPlanList, PlanItem, SnappayInfo } from "types/subscription";
import { useRouter } from "next/router";
import useSubscriptionExperiments from "@shared/hooks/useSubscriptionExperiments";
import { useMemo } from "react";

export const useSubscriptionPlans = () => {
  const { handleLogExperimentSubsPage } = useSubscriptionExperiments();
  const { push } = useRouter();
  const layoutData = useLayoutContext();
  const isMobile = useIsMobile(640);
  const { data } = useRequestImmutable(subscriptionApi.getPlans());
  const { data: activePlansData } = useRequestImmutable(
    layoutData.userData?.is_login ? subscriptionApi.checkUserPlan() : undefined
  );

  const openPayDetailModal = (planItm: PlanItem, _snappapy: SnappayInfo) => {
    handleLogExperimentSubsPage({
      action: SUBSCRIPTION_ACTION.ACTIVATE_PLAN,
      plan_id: planItm.id,
    });
    if (activePlansData?.data.is_active) {
      modalActions.addModal(MODAL_TYPES.SUBSCRIPTION_DETAIL, {
        config: { hideCloseIcon: true, draggableSheet: !!isMobile },
        data: {
          planItm: {
            ...activePlansData.data,
            plan_title: activePlansData.data.title,
          },
          title: "در حال حاضر یک اشتراک فعال دارید.",
        },
      });
    } else {
      push(`/subscription/checkout?plan=${planItm.id}`);
    }
  };

  const activePlanList = useMemo(() => {
    return (
      ((data as IPlanList) || [])?.data
        ?.filter((pln) => pln.is_active && !pln.is_hidden)
        .sort((a, b) => a.sort_order - b.sort_order) || []
    );
  }, [data?.data]);

  return {
    data,
    openPayDetailModal,
    layoutData,
    activePlanList,
  };
};
